export function getCreneauAppelUrl(baseUrl, contact) {
  const params = new URLSearchParams();

  if (contact?.email) {
    params.append('email', contact.email);
  }
  if (contact?.firstname) {
    params.append('firstname', contact.firstname);
  }
  if (contact?.lastname) {
    params.append('lastname', contact.lastname);
  }

  return params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
}

export function openCreneauAppel(baseUrl, contact, newTab = true) {
  window.open(
    getCreneauAppelUrl(baseUrl, contact),
    newTab ? '_blank' : '_self',
  );
}
